const ERROR_MSG_RECIPIENTS = 'Debe seleccionar un grupo a comunicar (y sus clubes), un grupo predeterminado' +
    ' o emails individuales.'

export const settlementsMixin = {
  data: () => ({
    saving: false,
    club: null,
    files: [],
    types: [],
    type: '',
    period: '',
    errorRecipients: ERROR_MSG_RECIPIENTS
  }),

  computed: {
    typeErrors () {
      return this.getRequiredErrors('type', 'El tipo es requerido.')
    },
    periodErrors () {
      const errors = []
      if (!this.$v.period.$dirty) return errors
      !this.$v.period.required && errors.push('El periodo es requerido.')
      !this.$v.period.minLength && errors.push('Faltan dígitos.')
      return errors
    },
    messageErrors () {
      return this.getRequiredErrors('message', 'La observación es requerida.')
    }
  },

  methods: {
    isValidForm () {
      if (!this.areCustomValidationsValid()) {
        this.handleCustomErrors()
        return false
      } else {
        this.$refs.emails.validateEmails()
        return !this.$v.$invalid && this.$refs.emails.isValid()
      }
    },
    areCustomValidationsValid () {
      let userDefinedPersonas = this.personas && this.personas.length && this.club != null
      if (!userDefinedPersonas) {
        if ((this.personas.length > 0 && this.club == null) ||
            (this.personas.length <= 0 && this.club != null)) {
          return false
        }
      }
      let userDefinedEmails = this.$refs.emails.getEmails().length > 0
      let userDefinedGrupos = this.grupos && this.grupos.length > 0
      return userDefinedPersonas || userDefinedEmails || userDefinedGrupos
    }
  }
}
